import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ru: {
    translation: {
      opengraph: {
        siteName: "Студия Пууул",
        title: "Студия Пууул",
      },
      common: {
        sitename: "пууул",
        more: "Подробнее",
        to_homepage: "На главную",
        scrollUp: "Вверх",
      },
      layout: {
        menu: {
          works: "Работы",
          team: "Команда",
          aboutUs: "О нас",
          contacts: "Контакты",
        },
        privacyPolicy: "Политика конфиденциальности",
      },
      errors: {
        not_found: "Такой страницы нет",
        forbidden: "Доступ запрещен",
        something_went_wrong: "Что-то пошло не так",
      },
      collections: {
        producer: "Продюсер",
        contacts: {
          telegram: "телеграм",
          whatsapp: "вотсапп",
        }
      },
      projects: {
        loadMore: "Загрузить ещё {{count}} из {{left}}",
        titlePrefix: "пууул:",
        contact: "Связаться",
        contactForm: {
          name: "Имя",
          namePlaceholder: "Как вас зовут?",
          company: "Компания",
          companyPlaceholder: "Название компании или бренда",
          email: "Почта",
          description: "Описание задачи",
          descriptionPlaceholder: "Пожалуйста, опишите задачу, сроки запуска проекта и планируемый бюджет",
          privacyPolicyConsent: "Соглашаюсь на обработку персональных данных в соответствии с",
          privacyPolicyPart: "политикой конфиденциальности",
        },
        contactSuccess: {
          text: "Ваше сообщение успешно отправлено, в ближайшее время мы с вами свяжемся",
          button: "Отлично",
        },
        filters: {
          all: "Все",
          more: "ещё {{amount}}",
          less: "свернуть",
        },
      },
    },
  },
  en: {
    translation: {
      opengraph: {
        siteName: "Poool Studio",
        title: "Poool Studio",
      },
      common: {
        sitename: "poool",
        more: "More",
        to_homepage: "Homepage",
        scrollUp: "Scroll Up",
      },
      layout: {
        menu: {
          works: "Works",
          team: "Team",
          aboutUs: "About Us",
          contacts: "Contacts",
        },
        privacyPolicy: "Privacy Policy",
      },
      errors: {
        not_found: "Page not found",
        forbidden: "Forbidden",
        something_went_wrong: "Something went wrong",
      },
      collections: {
        producer: "Producer",
        contacts: {
          telegram: "telegram",
          whatsapp: "whatsapp",
        }
      },
      projects: {
        loadMore: "Load {{count}} more out of {{left}}",
        titlePrefix: "poool:",
        contact: "Contact",
        contactForm: {
          name: "Name",
          namePlaceholder: "What is your name?",
          company: "Company",
          companyPlaceholder: "Company or brand name",
          email: "Email",
          description: "Work description",
          descriptionPlaceholder: "Briefly describe the work, launch dates, and planned budget",
          privacyPolicyConsent: "I agree to",
          privacyPolicyPart: "the Privacy Policy",
        },
        contactSuccess: {
          text: "Your message has been successfully sent, we'll reach out to you as soon as possible",
          button: "Got it",
        },
        filters: {
          all: "All",
          more: "{{amount}} more",
          less: "less",
        },
      },
    },
  },
};

export const setupI18n = (locale) => {
  i18n.use(initReactI18next).init({
    resources,
    lng: locale,
    fallbackLng: "ru",
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false,
    },
  });

  return i18n;
};
